import { Typography } from "@material-ui/core"

export const HumidityFreezeTestView = ({ procedureData }: { procedureData: any }) => {
  return (
    <div>
      <Typography variant="body1">
        Test temperature :{procedureData?.humidity_freeze?.test_temperature ?`${procedureData.humidity_freeze.test_temperature} °C`  : "N/A"} 
      </Typography>
      <Typography variant="body1">
        Test humidity :{procedureData?.humidity_freeze?.test_humidity ?`${procedureData.humidity_freeze.test_humidity} %RH`  : "N/A"} 
      </Typography>
      <Typography variant="body1">
        Equipment Calibration Date :{procedureData?.humidity_freeze?.equipment_calibration_date ? procedureData.humidity_freeze.equipment_calibration_date.substring(0, 10) : "N/A"}
      </Typography>
      <Typography variant="body1">
        Number of Cycles :{procedureData?.humidity_freeze?.number_of_cycles ? procedureData.humidity_freeze.number_of_cycles : "N/A"}
      </Typography>
      <Typography variant="body1">
        Applied Current Low:{procedureData?.humidity_freeze?.applied_current_low ?`${procedureData.humidity_freeze.applied_current_low} A`  : "N/A"} 
      </Typography>

      <Typography variant="body1">
        Current voltage normal : {procedureData?.humidity_freeze?.current_voltage_normal ? procedureData.humidity_freeze.current_voltage_normal : "N/A"}
      </Typography>

    </div>
  )
}